module.exports = function() {
  return new Worker(__webpack_public_path__ + "ca65c3423866e1088cfd.worker.js");
};